import { ModelMixin } from '../core/base-generic.model';

export class InterviewQuestionType extends ModelMixin<InterviewQuestionType>() {
    protected static _resource = 'applicantTracker/interviewQuestionTypes';
    protected static _version = 'v2';

    protected static _datetimes = ['createdAt', 'updatedAt', 'deletedAt'];

    get name(): string {
        return this._attributes['name'];
    }

    get description(): string {
        return this._attributes['description'];
    }

    get optionTypes(): string[] {
        return this._attributes['optionTypes'];
    }
}
